var map = {
	"./decidim/avatar-multiuser.png": 50907,
	"./decidim/brands/google.svg": 83050,
	"./decidim/cc-badge.png": 58089,
	"./decidim/decidim-logo.svg": 87497,
	"./decidim/default-avatar.svg": 59513,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 32575,
	"./decidim/icons.svg": 40760,
	"./decidim/pattern.png": 71979,
	"./decidim/placeholder-card-g.svg": 55320,
	"./decidim/placeholder-card-l.svg": 70547,
	"./decidim/placeholder.jpg": 34170,
	"./decidim/remixicon.symbol.svg": 72384,
	"./decidim/vendor/leaflet/layers-2x.png": 61785,
	"./decidim/vendor/leaflet/layers.png": 68144,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 28257,
	"./decidim/vendor/leaflet/marker-icon.png": 53832,
	"./decidim/vendor/leaflet/marker-shadow.png": 3575,
	"./decidim/vendor/social-share-button/douban.svg": 8595,
	"./decidim/vendor/social-share-button/email.svg": 24236,
	"./decidim/vendor/social-share-button/facebook.svg": 38680,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 16892,
	"./decidim/vendor/social-share-button/hacker_news.svg": 15872,
	"./decidim/vendor/social-share-button/linkedin.svg": 28682,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 47667,
	"./decidim/vendor/social-share-button/pinterest.svg": 61338,
	"./decidim/vendor/social-share-button/reddit.svg": 90992,
	"./decidim/vendor/social-share-button/telegram.svg": 23445,
	"./decidim/vendor/social-share-button/tumblr.svg": 50994,
	"./decidim/vendor/social-share-button/twitter.svg": 40041,
	"./decidim/vendor/social-share-button/vkontakte.svg": 28835,
	"./decidim/vendor/social-share-button/wechat.svg": 12494,
	"./decidim/vendor/social-share-button/whatsapp.svg": 9382,
	"./decidim/vendor/social-share-button/x.svg": 73124,
	"./decidim/vendor/social-share-button/xing.svg": 76756
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96502;